import classNames from 'classnames';

import { ClassNameType } from 'interfaces';

const styles = {
  component: (
    className: ClassNameType,
  ) => classNames(
    'bg-lightGray',
    'appearance-none',
    '!px-3',
    className,
  ),
};

export default styles;
